<script setup>
import { useStore } from 'vuex'
import emitter from '@/utils/emitter'
import router from '@/router'
import { EaseChatSDK, EaseChatClient } from '@/IM/initwebsdk'
import { handleSDKErrorNotifi } from '@/utils/handleSomeData'
import { informType } from '@/constant'
import { usePlayRing } from '@/hooks'
import ring from '@/assets/ring.mp3'
import { loginOutCustom } from '@/api/custom'
import { getImToken, getUserInfo } from '@/api/custom'
/* callkit */
import EaseCallKit from '@/components/EaseCallKit'
import InviteCallMembers from '@/components/InviteCallMembers'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { getToken, removeToken } from '@/utils/auth'
const store = useStore()
const { isOpenPlayRing, clickRing, playRing } = usePlayRing()
EaseChatSDK.logger.disableAll()

// 防抖控制 - 群组提示弹框
let lastGroupPromptTime = 0
const GROUP_PROMPT_DEBOUNCE = 1000 // 1秒防抖
const userType = computed(() => {
  return store.state.Conversation.userType
})

let userInfoHeartbeatTimer = null
let isRefreshingUserInfo = false
let isRelogging = false
let lastConnectedUser = null

const refreshUserInfo = async () => {
  if (router.currentRoute.value.path === '/login' || isRefreshingUserInfo) return
  isRefreshingUserInfo = true
  try {
    await getUserInfo()
  } catch (error) {
    console.error('用户信息心跳请求失败', error)
  } finally {
    isRefreshingUserInfo = false
  }
}

const handleWindowMessage = (event) => {
  if (!event) return

  let childData = ''
  try {
    childData = JSON.parse(event.data)
  } catch (error) {
    childData = event.data
  }

  if (childData && childData.type == 'logout') {
    // 退出登录
    window.localStorage.removeItem('hxUserToken')
    window.localStorage.removeItem('customUserInfo')
    window.localStorage.removeItem('EASEIM_loginUser')
    removeToken()
    loginOutCustom().then(() => {
      EaseChatClient.close()
      router.replace({
        path: '/login',
      })
    })
  }

  if (childData && childData.type == 'goChat') {
    router.push({
      path: '/chat/conversation',
      query: {
        id: childData.hxusername,
        chatType: childData.chatType,
        msgExtData: childData.msgExtData || '',
      },
    })
  }

  if (childData && childData.type == 'getUserInfoToParentWindow') {
    store.dispatch('getCustomUserInfo')
  }
}

onMounted(() => {
  // 自己服务器做个心跳包，定时请求接口，避免token超时
  if (userInfoHeartbeatTimer) clearInterval(userInfoHeartbeatTimer)
  userInfoHeartbeatTimer = setInterval(refreshUserInfo, 5 * 60 * 1000)
  store.dispatch('getLocalUnreadMsgIds')
  const token = getToken()
  if (token) {
    store.dispatch('GetInfo')
  }
  // 监听子窗口跳转会话页
  window.addEventListener('message', handleWindowMessage)
})
onUnmounted(() => {
  if (userInfoHeartbeatTimer) {
    clearInterval(userInfoHeartbeatTimer)
    userInfoHeartbeatTimer = null
  }
  window.removeEventListener('message', handleWindowMessage)
  const eventHandlerNames = ['connection', 'presenceStatusChange', 'messageListen', 'friendListen', 'groupEvent']
  eventHandlerNames.forEach((handlerName) => {
    EaseChatClient.removeEventHandler(handlerName)
  })
})
/* connect 相关监听 */
EaseChatClient.addEventHandler('connection', {
  onConnected: () => {
    //console.log('>>>>>环信连接成功')
    // 关闭时通知父窗口
    // if (window.opener && !window.opener.closed) {
    //     // window.opener.windowMessage
    //     // 关闭本窗口时进行提示
    //     window.addEventListener('beforeunload', function (event) {
    //         window.opener.postMessage('closed', 'https://erp.yududs.com')
    //         window.opener.postMessage('closed', 'http://yudu.yududs.com')
    //         window.opener.postMessage('closed', 'http://192.168.3.101')
    //         EaseChatClient.close()
    //     })
    // }
    store.commit('CHANGE_LOGIN_STATUS', true)
    isRelogging = false
    if (isOpenPlayRing.value) clickRing()
    if (lastConnectedUser && lastConnectedUser === EaseChatClient.user) {
      store.dispatch('refreshLoadedConversationOrders')
    } else {
      lastConnectedUser = EaseChatClient.user
      fetchLoginUsersInitData()
    }
    let show = window.sessionStorage.getItem('showNav')
    //console.log('%c Line:26 🍅 show', 'color:#33a5ff', show)
    // if(show) show = JSON.stringify(show)
    if (userType.value == 'erp') {
      router.replace({
        path: '/chat/conversation', //纯IM
        // path: '/chat/erp', //商户版
        query: { showNav: show ? show : true },
      })
    }
  },
  onDisconnected: async (e) => {
    // console.log("%c Line:66 🍆 e", "color:#7f2b82", e);
    // router.push('/login')
    window.localStorage.removeItem('EASEIM_loginUser')
    store.commit('CHANGE_LOGIN_STATUS', false)
    if (isRelogging) return
    EaseChatClient.close()
    // 重新登录
    if (router.currentRoute.value.path != '/login') {
      isRelogging = true
      try {
        let userInfos = await store.dispatch('getCustomUserInfo')
        if (userInfos) {
          // 重新登录环信
          let res2
          try {
            res2 = await getImToken()
          } catch (error) {}
          window.localStorage.setItem(`customUserInfo`, JSON.stringify(userInfos.data))
          // 用token登录IM
          try {
            let { accessToken } = await EaseChatClient.open({
              user: userInfos.data.hxusername.toLowerCase(),
              accessToken: res2.msg,
            })
            window.localStorage.setItem(
              `EASEIM_loginUser`,
              JSON.stringify({
                user: userInfos.data.hxusername,
                accessToken: accessToken,
              }),
            )
          } catch (error) {
            router.push('/login')
          }
        } else {
          router.push('/login')
        }
      } catch (error) {
        router.push('/login')
      } finally {
        isRelogging = false
      }
    }
    // //取本地的环信 usertoken hxUserToken
    // let usertoken = window.localStorage.getItem('hxUserToken')
    // let userInfos = window.localStorage.getItem('customUserInfo')
    // if (usertoken) usertoken = JSON.parse(usertoken)
    // if (userInfos) userInfos = JSON.parse(userInfos)
    // if (usertoken) {
    //     // 登录
    //     EaseChatClient.open({
    //         user: userInfos.hxusername.toLowerCase(),
    //         accessToken: usertoken
    //     })
    // } else {
    //     router.push('/login')
    // }
  },
  onOnline: () => {
    store.commit('CHANGE_NETWORK_STATUS', true)
  }, // 本机网络连接成功。
  onOffline: () => {
    store.commit('CHANGE_NETWORK_STATUS', false)
  }, // 本机网络掉线。
  onError: (error) => {
    // console.log('on error', error)
    if (error.type == 206) {
      // 设备超限 跳转登录页
      router.push('/login')
      handleSDKErrorNotifi(error.type, '登录设备过多')
    }
    // handleSDKErrorNotifi(error.type, error.message)
  },
})
//路由跳转-对应好友会话
const toChatMessage = (id, chatType, avatarurl) => {
  // //console.log('>>>>>>>id', id)
  router.push({
    path: '/chat/conversation/message',
    query: {
      id,
      chatType,
      avatarurl,
    },
  })
}
//fetch 登陆用户的初始数据
const fetchLoginUsersInitData = () => {
  getMyUserInfos()
  fetchFriendList()
  fetchTheLoginUserBlickList()
  // fetchGroupList()
  //初始化vuex中的会话列表相关数据
  store.commit('INIT_CONVERSATION_STATE')
  const userId = EaseChatClient.user
  store.dispatch('getSessionList', { userId }).then(() => {
    store.dispatch('refreshLoadedConversationOrders')
  })
}
//获取登陆用户属性
const getMyUserInfos = () => {
  const userId = EaseChatClient.user
  store.dispatch('getMyUserInfo', userId)
}
//获取好友列表
const fetchFriendList = () => {
  // const { value = {} } = useLocalStorage('friendList')
  // if (Object.values(JSON.parse(value)).length > 0) return
  store.dispatch('fetchFriendList')
}
//获取黑名单列表
const fetchTheLoginUserBlickList = () => store.dispatch('fetchBlackList')
//获取加入的群组列表
const fetchGroupList = () => {
  //如果本地存储里不存在群组列表则调用获取群组列表
  // const { value = {} } = useLocalStorage('groupList')
  // if (Object.values(JSON.parse(value)).length > 0) return
  const pageParams = {
    pageNum: 1,
    pageSize: 20,
  }
  store.dispatch('fetchGroupList', pageParams)
}
//在线状态订阅相关
const presenceStatus = (type, user) => {
  type === 'sub' && store.dispatch('subFriendsPresence', [user])
  type === 'unsub' && store.dispatch('unsubFriendsPresence', [user])
}

/* presence 相关监听 */
EaseChatClient.addEventHandler('presenceStatusChange', {
  onPresenceStatusChange: (status) => {
    //console.log('>>>>>presenceStatusChange', status)
    getUserPresence(...status)
  },
})
//处理登陆用户状态的变更
const getUserPresence = (status) => {
  store.dispatch('handlePresenceChanges', status)
}

const parseCmdAction = (action) => {
  if (!action) return {}
  if (typeof action === 'object') return action
  try {
    return JSON.parse(action)
  } catch (error) {
    return {}
  }
}

const handleOrderUpdateCmd = (action = {}) => {
  if (action.businessFunction === 'card_action_update') {
    if (action.messageId && action.state) {
      store.commit('UPDATE_BBUSINESS_MSG_STATE', {
        messageId: action.messageId,
        businessState: Number(action.state),
      })
    }
    const sessionId = action.toGroup || action.to
    if (sessionId) store.dispatch('refreshConversationOrder', { conversationKey: sessionId })
    return
  }
  if (action.businessFunction !== 'order_update') return
  const sessionId = action.to || action.toGroup
  if (!sessionId) return
  store.dispatch('refreshConversationOrder', { conversationKey: sessionId })
  emitter.emit('boost-order-update', sessionId)
}

/* message 相关监听 */
EaseChatClient.addEventHandler('messageListen', {
  onTextMessage: function (message) {
    pushNewMessage(message)
  }, // 收到文本消息。
  onEmojiMessage: function (message) {
    pushNewMessage(message)
  }, // 收到表情消息。
  onImageMessage: function (message) {
    //console.log('>>>>>>>App Image mesage', message)
    pushNewMessage(message)
  }, // 收到图片消息。
  onCmdMessage: function (message) {
    // action ："{"avatarUrl":"https://img.61xm.cn/9a847dcd9d9407f7019d94084ee60003.jpg","createTime":1775520064000,"del":1,"groupDesc":"订单交易群","groupName":"VHEL4WHR 11700w 结算中","groupType":"3","id":16387,"isCancel":1,"numbers":"{\"sanjiaozhouxiadankefu\":\"owner\",\"sanjiaozhou15307236454\":\"买家\",\"sanjiaozhou17776769260\":\"卖家\"}","toGroup":"310506070016001","updateTime":1776305869000}"
    // 收到命令消息。
    let action = parseCmdAction(message.action)
    handleOrderUpdateCmd(action)

    // 更新会话列表中对应群的名称和头像
    const toGroup = action.toGroup
    if (toGroup) {
      store.dispatch('getGroupDetail', { groupId: toGroup })
      // 订单类 cmd(指派跑手、申请结算等)可能改变群成员，同步刷新成员映射，避免昵称落到“用户”兜底
      store.dispatch('getGroupPersons', { groupId: toGroup, fromHxId: store.state.loginUserInfo?.hxId })
      // const conversationList = store.state.Conversation.conversationListData
      // if (conversationList[toGroup]) {
      //   const updated = { ...conversationList[toGroup] }
      //   if (action.groupName) updated.groupName = action.groupName
      //   if (action.avatarUrl) updated.avatarUrl = action.avatarUrl
      //   store.commit('UPDATE_CONVERSATION_LIST', { [toGroup]: updated })
      // }
    }
  }, // 收到命令消息。
  onAudioMessage: function (message) {
    pushNewMessage(message)
  }, // 收到音频消息。
  onLocationMessage: function (message) {
    pushNewMessage(message)
  }, // 收到位置消息。
  onFileMessage: function (message) {
    pushNewMessage(message)
  }, // 收到文件消息。
  onCustomMessage: function (message) {
    // console.log('>>>>>自定义消息', message)
    // if (
    //     message.customEvent == 'b_backorder' &&
    //     message.from == EaseChatClient.user
    // ) {
    //     return
    // }
    pushNewMessage(message)
  }, // 收到自定义消息。
  onVideoMessage: function (message) {
    pushNewMessage(message)
  }, // 收到视频消息。
  onRecallMessage: function (message) {
    otherRecallMessage(message)
  }, // 收到消息撤回回执。

  onReadMessage: function (message) {
    if (message.from != EaseChatClient.user) {
      store.commit('CHANGE_MESSAGE_BODAY', {
        type: 'read',
        key: message.from,
        mid: message.mid,
      })
    } else {
    }
  },
  onChannelMessage: (message) => {
    if (message.chatType == 'singleChat') {
      // 将这个会话下所有的消息都变为已读
      store.commit('CHANGE_MESSAGE_BODAY', {
        type: 'converReaded',
        key: message.from,
      })
    }
  },
  // onDeliveredMessage: function (message) {
  //   console.log("%c Line:200 🍻 消息已送达回执message", "color:#fca650", message);

  // },
})

/* 待发送的已读回执：key 为对方环信ID，value 为需要回执的消息ID列表 */
const pendingReadReceiptMap = {}
const MAX_PENDING_READ_RECEIPT = 100

const cacheReadReceipt = (message) => {
  const chatType = message.chatType || 'singleChat'
  if (chatType !== 'singleChat') return
  if (!message.id || message.from == EaseChatClient.user) return
  const ids = pendingReadReceiptMap[message.from] || (pendingReadReceiptMap[message.from] = [])
  if (ids.indexOf(message.id) > -1) return
  ids.push(message.id)
  if (ids.length > MAX_PENDING_READ_RECEIPT) ids.shift()
}

// 未读红点消失时，才把该会话缓存的消息补发已读回执
const sendPendingReadReceipts = (chatId) => {
  if (!chatId) return
  const ids = pendingReadReceiptMap[chatId]
  if (!ids || !ids.length) return
  delete pendingReadReceiptMap[chatId]
  ids.forEach((id) => {
    let option = {
      type: 'read', // 消息是否已读。
      chatType: 'singleChat', // 会话类型，这里为单聊。
      to: chatId, // 消息接收方的用户 ID。
      id, // 需要发送已读回执的消息 ID。
    }
    let msg = EaseChatSDK.message.create(option)
    EaseChatClient.send(msg).catch(() => {
      const queue = pendingReadReceiptMap[chatId] || (pendingReadReceiptMap[chatId] = [])
      if (queue.indexOf(id) == -1 && queue.length < MAX_PENDING_READ_RECEIPT) queue.unshift(id)
    })
  })
}

const pushNewMessage = (message) => {
  // 收到消息不再直接发送已读回执，先缓存，等未读红点消失时统一发送
  cacheReadReceipt(message)
  store.dispatch('createNewMessage', message).then(() => {
    if (message.chatType === 'groupChat' && message.to) {
      store.dispatch('refreshConversationOrder', {
        conversationKey: message.to,
        retryAfterCommit: true,
      })
    }
  })
}

// 点击聊天区域/向上滚动消息区/点击输入框/点击会话项，消除红点时最终都会提交 CLEAR_UNREAD_NUM
const unsubscribeReadReceipt = store.subscribe((mutation) => {
  if (mutation.type === 'CLEAR_UNREAD_NUM') sendPendingReadReceipts(mutation.payload)
})
onUnmounted(() => {
  unsubscribeReadReceipt()
})
//收到他人的撤回指令
const otherRecallMessage = (message) => {
  //console.log('>>>>>收到他人撤回', message)
  const { from, to, mid } = message
  //单对单的撤回to必然为登陆的用户id，群组发起撤回to必然为群组id 所以key可以这样来区分群组或者单人。
  const key = to === EaseChatClient.user ? from : to
  //console.log('>>>>>收到他人撤回', key)
  store.commit('CHANGE_MESSAGE_BODAY', { type: 'recall', key, mid })
  store.dispatch('gatherConversation', key)
}
/* 好友关系相关监听 */
const { INFORM_FROM } = informType
EaseChatClient.addEventHandler('friendListen', {
  // 收到好友邀请触发此方法。
  onContactInvited: (data) => {
    //写入INFORM
    //console.log('>>>>>>收到好友申请', data)
    submitInformData(INFORM_FROM.FRIEND, data)
  },
  // 联系人被删除时触发此方法。
  onContactDeleted: (data) => {
    //写入INFORM
    //console.log('>>>>收到好友关系解散', data)
    submitInformData(INFORM_FROM.FRIEND, data)
    //取消针对好友的在线状态订阅
    presenceStatus('unsub', data.from)
    //好友关系解除重新获取好友列表
    fetchFriendList()
  },
  // 新增联系人会触发此方法。
  onContactAdded: (data) => {
    //console.log('>>>>好友新增监听', data)
    submitInformData(INFORM_FROM.FRIEND, data)
    //新增好友重新获取好友列表
    fetchFriendList()
  },
  // 好友请求被拒绝时触发此方法。
  onContactRefuse: (data) => {
    //写入INFORM
    //console.log('>>>>>>好友申请被拒绝', data)
    data.type = 'other_person_refuse'
    submitInformData(INFORM_FROM.FRIEND, data)
  },
  // 好友请求被同意时触发此方法。
  onContactAgreed: (data) => {
    //写入INFORM
    //console.log('>>>>>对方同意了好友申请', data)
    //改掉data中的type
    data.type = 'other_person_agree'
    submitInformData(INFORM_FROM.FRIEND, data)
    //对方同意后重新获取好友列表
    fetchFriendList()
  },
})
/* 群组相关监听 */
EaseChatClient.addEventHandler('groupEvent', {
  onGroupEvent: (groupevent) => {
    if (groupevent.operation === 'directJoined') {
      // store.dispatch('getGroupDetail', { groupId: groupevent.id })
      // 进入新群聊提示是否转到群聊，添加防抖，1秒内只弹一次
      const now = Date.now()
      if (now - lastGroupPromptTime < GROUP_PROMPT_DEBOUNCE) {
        return
      }
      lastGroupPromptTime = now

      // ElMessageBox.confirm('请进入交易群进行交易？', '提示', {
      //   confirmButtonText: '确认',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // })
      //   .then(() => {
      //     // store.commit('CLEAR_UNREAD_NUM', groupevent.id)
      //     // 更新会话页面
      //     store.dispatch('reloadPage', {
      //       conversationKey: groupevent.id,
      //       flag: 'clickConversation',
      //       chatType: 'groupChat',
      //     })
      //     router.push({
      //       path: '/chat/conversation',
      //       query: {
      //         id: groupevent.id,
      //         chatType: 'groupChat',
      //         avatarurl: '',
      //       },
      //     })
      //   })
      //   .catch((err) => {})
      return
    }
    if (groupevent.operation === 'memberPresence') {
      return
    }
    submitInformData(INFORM_FROM.GROUP, groupevent)
  },
})
const submitInformData = (fromType, informContent) => {
  store.dispatch('createNewInform', { fromType, informContent })
}

/* 重新登陆 */
//读取本地EASEIM_loginUser
let EASEIM_loginUser = window.localStorage.getItem('EASEIM_loginUser')

if (EASEIM_loginUser) {
  EASEIM_loginUser = JSON.parse(EASEIM_loginUser)
}
const loginUserFromStorage = EASEIM_loginUser || {}
const handleRelogin = () => {
  //console.log('重新登陆')
  EaseChatClient.open({
    user: loginUserFromStorage.user,
    accessToken: loginUserFromStorage.accessToken,
  })
}
if (loginUserFromStorage?.user && loginUserFromStorage?.accessToken) {
  handleRelogin()
}
/* EaseCallKit 相关 */
const easeCallKit = ref(null)
const inviteCallComp = ref(null)
//多人会议使用-弹出邀请模态框
const showModal = ({ groupId }) => {
  //console.log('可以弹出邀请框', groupId)
  inviteCallComp.value.alertDialog(groupId)
}
//多人会议使用-传递给邀请组件发送邀请消息
const sendMulitInviteMsg = (targetIMId) => {
  //console.log('targetIMIdtargetIMIdtargetIMId', targetIMId)
  const callType = 2
  easeCallKit.value.inMultiChanelSendInviteMsg(targetIMId, callType)
}
</script>
<template>
  <router-view v-slot="{ Component }">
    <transition name="slide-fade" mode="out-in" :duration="{ enter: 500, leave: 300 }">
      <component :is="Component" />
    </transition>
  </router-view>
  <!-- 铃声标签 -->
  <audio id="ring" :src="ring" controls hidden></audio>
  <!-- About EaseCallKit -->
  <EaseCallKit
    ref="easeCallKit"
    :EaseIMClient="EaseChatClient"
    :msgCreateFunc="EaseChatSDK.message"
    @onInviteMembers="showModal"
  />
  <InviteCallMembers ref="inviteCallComp" @sendMulitInviteMsg="sendMulitInviteMsg" />
</template>

<style type="scss">
@import './styles/reset/reset.css';
@import './styles/iconfont/iconfont.css';

/* .el-dialog__header{
  background: #f2f2f2;
  margin: 0 !important;
} */
</style>
